import { Clock, Mail, MapPin, Phone, Briefcase } from "lucide-react";
import { ContactMap } from "@/components/contact/ContactMap";
import { ContactMethodCard } from "@/components/contact/ContactMethodCard";
import { ContactSocialLinks } from "@/components/contact/ContactSocialLinks";
import { site } from "@/content/site";
import { cn } from "@/lib/utils";

interface ContactInfoPremiumPanelProps {
  className?: string;
}

export function ContactInfoPremiumPanel({
  className,
}: ContactInfoPremiumPanelProps) {
  return (
    <div className={cn("contact-card space-y-6 p-6 md:p-8", className)}>
      <div>
        <h2 className="mb-4 text-xl font-bold text-[var(--contact-text)]">
          Visit Our Office
        </h2>
        <ContactMap heightClass="h-52 md:h-64" premium />
      </div>

      <div className="space-y-3 rounded-2xl border border-[var(--contact-border)] bg-[var(--contact-surface-muted)] p-4">
        <p className="flex items-start gap-3 text-sm text-[var(--contact-muted)]">
          <span className="contact-icon-circle contact-icon-circle-accent h-9 w-9">
            <MapPin size={16} className="m-auto" aria-hidden />
          </span>
          <span className="pt-1.5">{site.address.full}</span>
        </p>
        <p className="flex items-center gap-3 text-sm text-[var(--contact-muted)]">
          <span className="contact-icon-circle h-9 w-9">
            <Clock size={16} className="m-auto" aria-hidden />
          </span>
          <span>{site.contact.hours}</span>
        </p>
      </div>

      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        <ContactMethodCard
          icon={Phone}
          label="Call Us"
          value={site.contact.phone}
          href={site.contact.phoneHref}
          premium
        />
        <ContactMethodCard
          icon={Mail}
          label="Email Us"
          value={site.contact.email}
          href={`mailto:${site.contact.email}`}
          premium
        />
        <ContactMethodCard
          icon={Briefcase}
          label="CSR Inquiries"
          value={site.contact.csrEmail}
          href={`mailto:${site.contact.csrEmail}`}
          premium
        />
      </div>

      <div>
        <p className="mb-3 text-sm font-medium text-[var(--contact-muted)]">
          Follow Us
        </p>
        <ContactSocialLinks premium />
      </div>
    </div>
  );
}
